import { IconClockHour8, IconInfoCircle, IconTrash } from '@tabler/icons-react';

import { Button, Divider, Group, Loader, Stack, Switch, TextInput, Textarea } from '@optiro/ui';

import { MoveInterval } from '@/components/useIntervalResourceModal/MoveInterval';
import { MoveToNewTask } from '@/components/useIntervalResourceModal/MoveToNewTask/MoveToNewTask';
import type { Interval, Resource, Task } from '@/types/types';

interface IntervalDrawerContentViewProps {
  interval: Interval;
  resource: Resource | undefined;
  isLoading: boolean;
  formState: Partial<Interval>;
  taskId?: Task['id'];
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleToggleExcludeNonWorkingDays: (checked: boolean) => void;
  handleSubmit: () => void;
  handleDelete: () => void;
}

export function IntervalDrawerContentView({
  interval,
  resource,
  isLoading,
  formState,
  taskId,
  handleChange,
  handleToggleExcludeNonWorkingDays,
  handleSubmit,
  handleDelete,
}: IntervalDrawerContentViewProps) {
  if (isLoading || !resource) return <Loader />;

  return (
    <Stack gap="xs">
      <MoveInterval resource={resource} interval={interval} />
      <MoveToNewTask interval={interval} preselectedTaskId={taskId} />
      <Divider label="Interval indstillinger" labelPosition="left" />
      <TextInput
        label="Timer pr dag"
        leftSection={<IconClockHour8 size={16} />}
        name="hours_each_day"
        size="md"
        type="number"
        value={String(formState.hours_each_day || '')}
        onChange={handleChange}
      />
      <Textarea
        label="Kommentar"
        name="comment"
        size="md"
        value={formState.comment || ''}
        onChange={handleChange}
        leftSection={<IconInfoCircle size={16} />}
      />
      <Switch
        label="Udelad weekender og lukkedage"
        checked={!!formState.exclude_non_working_days}
        onChange={(e) => handleToggleExcludeNonWorkingDays(e.currentTarget.checked)}
      />
      <Group justify="space-between" mt="md">
        <Button
          variant="outline"
          color="red"
          leftSection={<IconTrash size={15} />}
          onClick={handleDelete}
        >
          Slet interval
        </Button>
        <Button onClick={handleSubmit}>Gem</Button>
      </Group>
    </Stack>
  );
}
